export default function PHP_ClassesObjects() {
  return (
    <div>
      <h1>PHP_ClassesObjects</h1>
    </div>
  );
}
